import React from 'react';

import { themeColors } from 'themes/clients/baseTheme';

import { GOAL_PROGRESSES, GOAL_PROGRESSES_FULL_LABEL, getGoalStatusColorObject } from 'constants/ProjectConstants';
import { notNullOrUndefined } from 'constants/helper';

import { ProgressBar } from 'uiToolkitV1/ProgressBar';

const KEYS_FOR_PROGRESS_BAR = GOAL_PROGRESSES.map(({ value }) => value);

const COLOR_MAP = {
  ON_TRACK: '#B1E39F',
  OFF_TRACK: '#FCC88B',
  AT_RISK: '#FD9B9B',
  CLOSED: '#666666',
};

export const COLOR_MAP_GOALS = {
  ON_TRACK: { barColor: '#B1E39F', textColor: themeColors.functional['2F8133'] },
  OFF_TRACK: { barColor: '#FCC88B', textColor: themeColors.functional.B96400 },
  AT_RISK: { barColor: '#FD9B9B', textColor: themeColors.functional.C62C02 },
  CLOSED: { barColor: '#666666', textColor: themeColors.common.white },
};

const ObjectiveProgressBarAgGrid = ({ data, percentageValue, isGoalProgressbar, progressLevel, goalClosureStatus }) => {
  const parentProgressLevel = progressLevel;

  const modifiedData = KEYS_FOR_PROGRESS_BAR.map((progressLevel) => {
    if (notNullOrUndefined(data[progressLevel]?.avgPercentage)) {
      return {
        weight: +data[progressLevel]?.avgPercentage === 0 ? 1 : +data[progressLevel]?.avgPercentage,
        color: COLOR_MAP[progressLevel],
        value: progressLevel,
      };
    }
  }).filter((dObj) => !!dObj);

  let goalProgressLevel = progressLevel;
  goalProgressLevel = goalProgressLevel ?? 'ON_TRACK';

  const label = goalClosureStatus
    ? GOAL_PROGRESSES_FULL_LABEL[`${goalProgressLevel}_${goalClosureStatus}`]
    : GOAL_PROGRESSES_FULL_LABEL[goalProgressLevel];

  const progressColors = getGoalStatusColorObject(goalProgressLevel, goalClosureStatus);

  if (isGoalProgressbar) {
    return (
      <ProgressBar
        size="large"
        color={progressColors?.tagColor}
        text={label}
        textColor={progressColors?.textColor}
        value={+percentageValue?.toFixed(2)}
        showPercentage
        percentageMinWidth="5ch"
      />
    );
  }

  return (
    <ProgressBar
      size="large"
      text={label}
      color={progressColors?.tagColor}
      textColor={progressColors?.textColor}
      value={+percentageValue?.toFixed(2)}
      showPercentage
      percentageMinWidth="5ch"
    />
  );

  // return (
  //   <SplitProgressBar
  //     size="large"
  //     data={modifiedData}
  //     totalWeight={100}
  //     showPercentage
  //     percentageValue={+percentageValue?.toFixed(2)}
  //   />
  // );
};

export { ObjectiveProgressBarAgGrid };
